export const ACCEPT_ATTR = "image/jpeg,image/jpg,image/png";
const ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png"];
const MAX_MB = 5;

// Match these limits with your worker-app aadhaarHelpers if they differ
export const validateImageFile = (file) => {
  if (!ALLOWED_TYPES.includes(file.type)) return "Only JPG or PNG images are allowed.";
  if (file.size > MAX_MB * 1024 * 1024) return `Image must be under ${MAX_MB} MB.`;
  return "";
};

// Accepts YYYY-MM-DD(...), DD-MM-YYYY, DD/MM/YYYY → "YYYY-MM-DD" for <input type="date">
export const normalizeDobForInput = (dob) => {
  if (!dob) return "";
  if (/^\d{4}-\d{2}-\d{2}/.test(dob)) return dob.split("T")[0];
  const m = dob.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  return "";
};

export const validateAge = (birthDate) => {
  const today = new Date();
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age >= 16;
};

// returns true when dob + address are usable as-is
export const areDetailsValid = (dob, address) =>
  !!dob && validateAge(dob) && (address || "").trim().length >= 5;